import isRegExp from 'lodash/isRegExp';
import { readApiErrorTypeDef } from '../readApiErrorTypeDef';

function checkReadApiErrorStatus(
  error: unknown,
  status: RegExp | number
): boolean {
  if (
    !readApiErrorTypeDef(error) ||
    !error?.response?.data?.error?.statusCode ||
    !status
  ) {
    return false;
  }

  if (isRegExp(status)) {
    return status.test(String(error.response.data.error.statusCode));
  }

  return status === error.response.data.error.statusCode;
}

export default checkReadApiErrorStatus;
